import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'obeta',
} as IModuleProps;
